var $ = require('jquery');

var platform = null;

var buildURL = function (func, adID) {
    // Not all browsers support location.origin
    var baseURL = location.protocol + '//' + location.host;
    return baseURL + "/adbanner/" + func + "/" + adID + "/" + platform + "/";
};

var registerBannerClick = function (adID) {
    $.get(buildURL('click', adID));
};

var registerBannerView = function (adID) {
    $.get(buildURL('view', adID));
};

var loadAdBanner = function (bannerImg) {
    bannerImg[0].src = bannerImg.data('src');
};

var isMobileSize = function () {
    // This includes scrollbar and is not the most
    // accurate calculation anyway, but close enough.
    var w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
    return w < 640;
};

$(function () {
    platform = isMobileSize() ? 'm' : 'd';
    for (var i = 1; i < 4; i++) {
      let adID = $(`#ad-banner-${i}`).data('id');
      var imageSelector = `#ad-banner-${i} .ad-image.${platform}`;

      var bannerImage = $(imageSelector);
      if (bannerImage.length) {
          bannerImage[0].addEventListener('load', () => registerBannerView(adID));
          $(`#ad-banner-${i} a`).on('click', () => registerBannerClick(adID));
          loadAdBanner(bannerImage);
      }
    }
});



//////////////////
// WEBPACK FOOTER
// ./common/js/ad_banner.js
// module id = 6
// module chunks = 0